module.exports = __webpack_public_path__ + "img/FLSH1.50fa6892.svg";